<template>
    <button :style="style" v-if="type == 'button'" :class="[variant, { 'loading': loading, 'disabled': disabled }]" @click="handleClick" :disabled="disabled || loading">
        <span v-if="loading" class="loading-spinner">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416" class="spinner-circle"/>
            </svg>
            <slot></slot>
        </span>
        <span v-else class="button-content">
            <slot></slot>
        </span>
    </button>
    <a v-if="type == 'link'" :href="link" :class="[variant, { 'loading': loading, 'disabled': disabled }]" @click="handleClick">
        <span v-if="loading" class="loading-spinner">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416" class="spinner-circle"/>
            </svg>
            <slot></slot>
        </span>
        <span v-else class="button-content">
            <slot></slot>
        </span>
    </a>
</template>
<script>
export default {
    name: 'EWButton',
    props: {
        type: {
            type: String,
            default: 'button'
        },
        link: {
            type : String,
            default : ''
        },
        variant: {
            type: String,
            default: ''
        },
        style: {
            type: Object,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick(event) {
            this.$emit('click', event);
        }
    }
};
</script>
<style scoped>
    button, a{
        text-decoration: none;
        display: flex;
        padding: 15px 56px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 42px;
        color: #fff;
        font-size: 16px;
        border: none;
        align-self: stretch;
        font-family: 'Bounded';
        font-weight: 400;
        border-radius: 10px;
        background: light-dark(#000, #ffffff);
        color: light-dark(#fff, #000);
        position: relative;
        transition: all 0.3s ease;
        cursor: pointer;
    }
    
    button.disabled, a.disabled {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
    }
    
    button.loading, a.loading {
        pointer-events: none;
    }
    
    .button-content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    
    .loading-spinner {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        width: 100%;
    }
    
    .spinner-circle {
        animation: spin 1s linear infinite;
        transform-origin: center;
    }
    
    @keyframes spin {
        from {
            rotate: 0;
        }
        to {
            rotate: 360deg;
        }
    }
    
    .secondary{
        background-color: #ace715;
        color: #000
    }
    
    .secondary.loading {
        background-color: #9bd613;
    }
    
    .w-full{
        width: 100%;
    }
</style>